var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _circle2, _circle3, _circle4, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 243,
    viewBox: "0 0 228 243",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1888_39347)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.563,
    cy: 121.395,
    rx: 73.5,
    ry: 80.8922,
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.563 121.395C186.563 165.84 153.836 201.787 113.563 201.787C73.2902 201.787 40.563 165.84 40.563 121.395C40.563 76.9494 73.2902 41.0028 113.563 41.0028C153.836 41.0028 186.563 76.9494 186.563 121.395Z",
    stroke: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190.063 67.5C181.945 64.5494 165.699 82.6568 160.045 86.5C160.046 86.5018 160.05 86.5107 160.057 86.5264C160.508 87.5409 173.483 117.17 177.682 131.692C177.751 131.933 177.818 132.169 177.883 132.401C188.572 104.03 197.239 83.5301 196.563 77.5C196.563 71.5 192.248 68.2945 190.063 67.5Z",
    fill: "#FFFF38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5379 67.5C40.6074 65.6572 48.8476 72.0281 55.6982 78.0081C60.348 82.0671 66.5775 84.5 65.2199 87.1712C65.1833 87.4165 65.1147 87.6703 65.0114 87.9339C64.5674 89.0671 63.82 90.06 63.3292 91.1737C62.1276 93.9005 59.6017 99.7124 56.7412 106.767L52.1191 119.293L47.497 131.818C36.8079 103.447 28.3618 83.5301 29.0379 77.5C29.0379 71.5 33.3522 68.2945 35.5379 67.5Z",
    fill: "#FFFF38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.255 177.582C110.449 178.286 112.771 178.921 123.344 177.58C126.58 188.017 137.534 208.891 155.467 208.891C163.161 208.891 170.742 206.181 175.521 200.716C187.228 189.685 186.175 162.175 177.883 132.401L177.682 131.692C173.483 117.17 160.508 87.5409 160.057 86.5264C149.743 66.073 137.137 48.2518 124.32 38.4236C117.83 33.4472 107.844 34.2898 101.271 38.4236C88.3195 48.355 75.5925 66.4479 65.2199 87.1712C65.1833 87.4165 65.1147 87.6703 65.0114 87.9339C64.5674 89.0671 63.82 90.06 63.3292 91.1737C62.1276 93.9005 59.6017 99.7124 56.7412 106.767L47.497 131.818C39.2047 161.592 38.3723 189.685 50.0792 200.716C54.8585 206.181 62.4391 208.891 70.1335 208.891C88.065 208.891 99.0189 188.02 102.255 177.582Z",
    fill: "#FFFF38"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8336 119.569L55.9776 108.609C56.9602 106.244 54.0647 112.099 55 110C51.5 116.5 46.5 123.5 45.5 126.5L47.5 132L51.8336 119.569Z",
    fill: "#ACAC22"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M173.566 120.119L169.422 109.159C168.44 106.794 171.335 112.649 170.4 110.55C173.9 117.05 178.9 124.05 179.9 127.05L177.9 132.55L173.566 120.119Z",
    fill: "#ACAC22"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.062 107.738C108.517 109.399 112.953 111.725 119.062 107.738",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108.062 86.7266H118.062",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 133.062,
    cy: 87,
    r: 5,
    fill: "black",
    stroke: "black",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.0625,
    cy: 87,
    r: 5,
    fill: "black",
    stroke: "black",
    strokeWidth: 4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2,
    transform: "matrix(1 0 0 -1 132.062 87)",
    fill: "white",
    stroke: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2,
    transform: "matrix(1 0 0 -1 92.0625 87)",
    fill: "white",
    stroke: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M107.829 85.5C107.829 98.7204 96.8354 109.5 83.1958 109.5C69.5563 109.5 58.5625 98.7204 58.5625 85.5C58.5625 72.2796 69.5563 61.5 83.1958 61.5C96.8354 61.5 107.829 72.2796 107.829 85.5ZM167.562 85.5C167.562 98.7204 156.569 109.5 142.929 109.5C129.29 109.5 118.296 98.7204 118.296 85.5C118.296 72.2796 129.29 61.5 142.929 61.5C156.569 61.5 167.562 72.2796 167.562 85.5Z",
    fill: "#D9D9D9",
    fillOpacity: 0.25,
    stroke: "black",
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6621 176.66C92.6621 176.66 97.007 177.102 102.255 177.581C101.913 178.662 101.513 179.857 101.005 181.126L92.6621 176.66Z",
    fill: "#ACAC22"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M132.9 176.66C132.9 176.66 128.555 177.102 123.307 177.581C123.649 178.662 124.049 179.857 124.557 181.126L132.9 176.66Z",
    fill: "#ACAC22"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1888_39347",
    x: 0.0629883,
    y: 0.502808,
    width: 227,
    height: 241.784,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect1_foregroundBlur_1888_39347"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar1);
export default __webpack_public_path__ + "static/media/star1.bae14577c98564a34e842a0dfb73947f.svg";
export { ForwardRef as ReactComponent };